(() => {
  if (customElements.get("tabs-main")) {
    return;
  }

  /**
   * Tabs main component.
   */
  class TabsMain extends HTMLElement {
    /**
     * Constructor.
     */
    constructor() {
      super();

      this.tabs = this.querySelectorAll("[data-tab]");
      this.button = this.querySelectorAll("[data-button]");
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      [...this.button].forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
      );
    }

    /**
     * Handle button click.
     *
     * @param {Event} event
     * @returns {String}
     */
    onButtonClick(event) {
      event.preventDefault();
      const target = event.target;
      const parent = target.parentNode;
      const tabId = target.getAttribute("data-tab-id");
      const element = this.querySelector(`#${tabId}`);

      if (!element) return;

      [...this.tabs].forEach((tab) => tab.classList.remove("is-active"));
      [...this.button].forEach((button) =>
        button.parentNode.classList.remove("is-active")
      );

      element.classList.add("is-active");
      parent.classList.add("is-active");
    }
  }

  customElements.define("tabs-main", TabsMain);
})();
